import { render, staticRenderFns } from "./AppSidebar.vue?vue&type=template&id=4a07241b"
import script from "./AppSidebar.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppSidebar.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports